"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeepLinkDispatch = exports.useDeepLinkState = exports.DispatchContext = exports.StateContext = exports.StateKeys = exports.Actions = void 0;

var _react = require("react");

var Actions;
exports.Actions = Actions;

(function (Actions) {
  Actions["SET"] = "SET";
  Actions["UNSET"] = "UNSET";
  Actions["EMPTY"] = "EMPTY";
})(Actions || (exports.Actions = Actions = {}));

var StateKeys;
exports.StateKeys = StateKeys;

(function (StateKeys) {
  StateKeys["Cart"] = "cart";
  StateKeys["Promo"] = "promo";
  StateKeys["ItemType"] = "itemType";
})(StateKeys || (exports.StateKeys = StateKeys = {}));

var StateContext = (0, _react.createContext)(undefined);
exports.StateContext = StateContext;
var DispatchContext = (0, _react.createContext)(undefined);
exports.DispatchContext = DispatchContext;

var useDeepLinkState = function useDeepLinkState() {
  var context = (0, _react.useContext)(StateContext);

  if (context === undefined) {
    throw new Error('useDeepLinkState must be used within DeepLinkProvider');
  }

  return context;
};

exports.useDeepLinkState = useDeepLinkState;

var useDeepLinkDispatch = function useDeepLinkDispatch() {
  var context = (0, _react.useContext)(DispatchContext);

  if (context === undefined) {
    throw new Error('useDeepLinkDispatch must be used within DeepLinkProvider');
  }

  return context;
};

exports.useDeepLinkDispatch = useDeepLinkDispatch;